import React, {FC} from 'react';
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";

const ThemeConfig: FC<{children: any}> = ({children}) => {

    const theme = createTheme({
        palette: {
            mode: 'dark',
            primary: {
                main: '#860000',
            },
            secondary: {
                main: '#860000',
            },
        },
    })

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            {children}
        </ThemeProvider>
    );
};

export default ThemeConfig;
